import Modal from "react-modal";
import React, { useEffect, useState } from "react";
import Styles from "../../Report/report.module.css";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import ReactLoading from "react-loading";
import { Services } from "Services";
import { warningSwal } from "Util/Toast";
import Select from "react-select";
import { AiOutlineClose } from "react-icons/ai";
import swal from "sweetalert";
Modal.setAppElement("#root");

const DemoForm = ({ modal, setModal, getDetails, id }) => {
    const {
        handleSubmit,
        reset,
        register,
        setValue,
        control,
        watch,

        formState: { errors },
    } = useForm({ defaultValues: { is_partial_completed: false } });
    const token = {
        Authorization: `token ${localStorage.getItem("token")}`,
    };
    const [lessonPlan, setLessonPlan] = useState([]);
    const [partial, setPartial] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState([]);
    const [isRevision, setIsRevision] = useState(false);
    const [loading, setLoading] = useState(false);
    const [load, setLoad] = useState(false);
    const getLessonPlan = async (revision = false) => {
        setLoading(true);
        console.log(getDetails.data);
        try {
            if (revision) {
                // fetch lesson plans by course for revision classes
                const courseId = getDetails?.data?.CourseID;
                if (!courseId) {
                    throw new Error("CourseID missing");
                }
                const res = await Services.get_Course_Lessons(
                    "GET",
                    null,
                    token,
                    courseId
                );
                if (res?.Status === 1 && Array.isArray(res?.LessonPlans)) {
                    const opts = res.LessonPlans.map((item) => ({
                        label: `${item.PlanNumber}`,
                        value: item.PlanNumber,
                    }));
                    setLessonPlan(opts);
                    setPartial(opts);
                }
            } else {
                let body = {
                    LessonPlans_Batch: getDetails.data.LessonPlans_Batch,
                    CourseID: getDetails.data.CourseID,
                };
                const getCourseDetails = await Services.get_Lesson_Plan(
                    "POST",
                    JSON.stringify(body),
                    token
                );
                if (getCourseDetails.Status === 1) {
                    const opts = getCourseDetails.PendingLessonPlans.map(
                        (item) => ({
                            label: item.PlanNumber,
                            value: item.PlanNumber,
                        })
                    );
                    setLessonPlan(opts);
                    setPartial(opts);
                }
            }
        } catch (err) {
            console.log(err);
            warningSwal("Error", "Something went wrong please try again");
        } finally {
            setLoading(false);
        }
    };
    const findNonCommonObjects = (arr1, arr2) => {
        const arr2Set = new Set(arr2.map((obj) => JSON.stringify(obj)));
        return arr1.filter((obj) => !arr2Set.has(JSON.stringify(obj)));
    };

    useEffect(() => {
        // fetch initial lesson plans; if revision toggled, fetch accordingly
        getLessonPlan(isRevision);
    }, [isRevision]);
    const watchData = watch();
    // CLOSE FORM
    const closeModal = () => {
        setModal(false);
        reset();
    };

    // FORM SUBMIT
    const onSubmit = async (formdata) => {
        setLoad(true);
        let Body = {
            CourseID: getDetails?.data?.CourseID,
            Students: getDetails.data?.Students,
            ScheduleClassID: getDetails?.data?.ScheduleClassID,
            Students: getDetails?.data?.Students,
            FeePerHour: getDetails?.data?.FeePerHour,
            BatchName: getDetails?.data?.BatchName,
            Scheduled_StartTime: getDetails?.data?.Scheduled_StartTime,
            TutorID: getDetails?.data?.TutorID,
            Comments: formdata.Comments,
            NewTopicDone: formdata.NewTopicDone,
            Duration: getDetails?.data?.Duration,
            ClassDuration: getDetails?.data?.ClassDuration,
            BatchSize: getDetails?.data?.BatchSize,
            TutorEmailID: getDetails?.data?.TutorEmailID,
            Scheduled_StartDate:
                getDetails?.data?.Scheduled_StartDate &&
                getDetails?.data?.Scheduled_StartDate != "NA" &&
                String(getDetails?.data?.Scheduled_StartDate).split("T")[0],
            BatchID: getDetails?.data?.BatchID,
            LessonPlans_Batch: getDetails?.data?.LessonPlans_Batch,
            PlanNumber_Batch: getDetails?.data?.PlanNumber_Batch,
            PartiallyCompleted: {
                IsPartiallyCompleted: 0,
            },
            IsRevision: isRevision ? 1 : 0,
            LessonPlans_Class: selectedPlan.map((item) => item.value),
        };
        if (watchData.is_partial_completed) {
            Body = {
                ...Body,
                IsRevision: isRevision ? 1 : 0,
                PartiallyCompleted: {
                    IsPartiallyCompleted: 1,
                    Slide: formdata.SlideNumber,
                    LessonPlan: formdata.Lesson?.value,
                },
            };
        }
        try {
            const CompleteClass = await Services.Complete_Class(
                "POST",
                JSON.stringify(Body),
                token
            );
            setLoad(false);
            if (CompleteClass.Status === 1) {
                swal("Completed", CompleteClass.Message, "success");
                setModal(false);
                getDetails?.details(id);
            } else {
                warningSwal("Warning", CompleteClass?.Message);
            }
        } catch (err) {
            setLoad(false);
            console.log(err);
            warningSwal("Error", "Something went wrong please try again");
        }
    };
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: state.hasValue ? "3.3rem" : "3rem", // Adjust the height based on your preference
        }),
    };
    const onPlanSelect = (data) => {
        setPartial(findNonCommonObjects(lessonPlan, data));
        setValue("Lesson", []);
        setSelectedPlan(data);
    };
    const blurHandler = (e) => {
        e.preventDefault();
        e.target.blur();

        return false;
    };
    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            const target = e.target;
            // allow Enter inside textarea
            if (target && target.tagName !== "TEXTAREA") {
                e.preventDefault();
            }
        }
    };

    return (
        <Modal
            isOpen={modal}
            contentLabel="Modal"
            className={Styles["modal"]}
            onRequestClose={closeModal}
            overlayClassName={Styles["overlay"]}>
            <div className={Styles["form-wrapper"]}>
                <button onClick={closeModal}>
                    <AiOutlineClose />
                </button>
                <h2>Complete Class</h2>
                <form
                    onSubmit={handleSubmit(onSubmit)}
                    onKeyDown={handleKeyDown}>
                    <div className={Styles["form-control"]}>
                        <label htmlFor=""> Completed File Number/s :</label>
                        <Controller
                            name="LessonPlans_Class"
                            control={control}
                            defaultValue={[]}
                            rules={{
                                required:
                                    watchData.is_partial_completed == 1
                                        ? false
                                        : "This field is required",
                            }}
                            render={({ field }) => (
                                <>
                                    <Select
                                        {...field}
                                        options={lessonPlan}
                                        styles={customStyles}
                                        isSearchable={false}
                                        onChange={(val) => {
                                            // update react-hook-form value and local state/partials
                                            field.onChange(val);
                                            onPlanSelect(val);
                                        }}
                                        value={field.value}
                                        placeholder="Select plan"
                                        isMulti
                                        isLoading={loading}
                                        closeMenuOnSelect={false}
                                        className={Styles["select"]}
                                        classNames={{
                                            control: (state) =>
                                                Styles["control"],
                                            indicatorSeparator: () =>
                                                Styles["indicator"],
                                            valueContainer: () =>
                                                Styles["valueContainer"],
                                            input: () => Styles["input"],
                                            indicatorsContainer: () =>
                                                Styles["indicationContainer"],
                                            singleValue: () =>
                                                Styles["singleValue"],
                                            option: () => Styles["option"],
                                            menu: () => Styles["menu"], // class for the options container
                                            menuList: () => Styles["menuList"],
                                        }}
                                    />
                                    <p></p>
                                    {errors.LessonPlans_Class && (
                                        <p
                                            className={Styles["error-msg"]}
                                            style={{ color: "red" }}>
                                            This is required
                                        </p>
                                    )}
                                </>
                            )}
                        />
                    </div>
                    {watchData.is_partial_completed && (
                        <div className={Styles["form-control"]}>
                            <label htmlFor="">
                                Partially Completed File Number/s :
                            </label>
                            <Controller
                                name="Lesson"
                                control={control}
                                defaultValue={""}
                                rules={{
                                    required: "This field is required",
                                }}
                                render={({ field }) => (
                                    <>
                                        <Select
                                            {...field}
                                            options={partial}
                                            styles={customStyles}
                                            isSearchable={false}
                                            placeholder="Select plan"
                                            isLoading={loading}
                                            closeMenuOnSelect={true}
                                            className={Styles["select"]}
                                            classNames={{
                                                control: (state) =>
                                                    Styles["control"],
                                                indicatorSeparator: () =>
                                                    Styles["indicator"],
                                                valueContainer: () =>
                                                    Styles["valueContainer"],
                                                input: () => Styles["input"],
                                                indicatorsContainer: () =>
                                                    Styles[
                                                        "indicationContainer"
                                                    ],
                                                singleValue: () =>
                                                    Styles["singleValue"],
                                                option: () => Styles["option"],
                                                menu: () => Styles["menu"], // class for the options container
                                                menuList: () =>
                                                    Styles["menuList"],
                                            }}
                                        />
                                        <p></p>
                                        {errors.Lesson && (
                                            <p
                                                className={Styles["error-msg"]}
                                                style={{ color: "red" }}>
                                                This is required
                                            </p>
                                        )}
                                    </>
                                )}
                            />
                        </div>
                    )}
                    {watchData.is_partial_completed && (
                        <div className={Styles["form-control"]}>
                            <label htmlFor="Comments">
                                Slide Number <span>:</span>
                            </label>
                            <div className={Styles["form-control-one"]}>
                                <input
                                    type="number"
                                    onWheel={blurHandler}
                                    onScroll={blurHandler}
                                    placeholder="Slide number"
                                    {...register("SlideNumber", {
                                        required: true,
                                    })}
                                />
                                {errors.SlideNumber && (
                                    <span className={Styles["error"]}>
                                        Slide Number is required
                                    </span>
                                )}
                            </div>
                        </div>
                    )}
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">
                            Topic taken today <span>:</span>
                        </label>
                        <div className={Styles["form-control-one"]}>
                            <input
                                type="text"
                                {...register("NewTopicDone", {
                                    required: true,
                                })}
                            />
                            {errors.NewTopicDone && (
                                <span style={{ color: "red" }}>
                                    This is required
                                </span>
                            )}
                        </div>
                    </div>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="Comments">
                            Description of Topic <span>:</span>
                        </label>
                        <div className={Styles["form-control-one"]}>
                            <textarea
                                style={{ width: "100%" }}
                                {...register("Comments", {
                                    required: true,
                                })}></textarea>
                            {errors.Comments && (
                                <span style={{ color: "red" }}>
                                    This is required
                                </span>
                            )}
                        </div>
                    </div>

                    <div className={Styles["radio-buttons"]}>
                        <label>
                            <Controller
                                name="is_partial_completed"
                                control={control}
                                defaultValue={1}
                                render={({ field }) => (
                                    <>
                                        <input
                                            type="checkbox"
                                            {...field}
                                            value={2}
                                        />
                                        <span
                                            className={Styles["span"]}
                                            style={{ color: "red" }}>
                                            {" "}
                                            Partially Completed
                                        </span>
                                    </>
                                )}
                            />
                        </label>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.3rem",
                        }}>
                        <div>
                            <input
                                type="checkbox"
                                checked={isRevision}
                                onChange={(e) => {
                                    const val = e.target.checked;
                                    setIsRevision(val);
                                    // reset selected plans when switching modes
                                    setSelectedPlan([]);
                                    setValue("LessonPlans_Class", []);
                                    setValue("Lesson", "");
                                }}
                            />
                        </div>
                        <label style={{ color: "red" }}>Revision Done</label>
                    </div>
                    {/* eslint-disable-next-line */}
                    {load ? (
                        <div style={{ justifySelf: "center" }}>
                            <ReactLoading
                                color="green"
                                type="spokes"
                                height={30}
                                width={30}
                            />
                        </div>
                    ) : (
                        <div className={Styles["buttons"]}>
                            <button type="submit" className={Styles["submit"]}>
                                Complete
                            </button>
                            <button
                                type="button"
                                onClick={closeModal}
                                className={Styles["close"]}>
                                Cancel
                            </button>
                        </div>
                    )}
                </form>
            </div>
        </Modal>
    );
};
export default DemoForm;
